<template>
  <div class="content">
    <div id="userChart" style="width: 100%;height: 100%"></div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'

  export default {
    name: 'TopLeft',
    data () {
      return {
        userChart: null,
      }
    },
    mounted () {
      this.userChart = echarts.init(document.getElementById('userChart'))
      this.draw(['2020-02-10', '2020-02-11', '2020-02-12', '2020-02-13', '2020-02-14'], [84, 12, 34, 64, 75])


      window.onresize = () => {
        return (() => {
          this.userChart.resize()
        })();
      };

    },
    methods: {
      draw (refDate, messageCount) {
        // 绘制图表
        this.userChart.setOption({
          title: false,
          tooltip: { trigger: 'axis' },
          legend: { data: ['消息数'] },
          grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
          xAxis: { type: 'category', boundaryGap: false, data: refDate },
          yAxis: { type: 'value' },
          series: [{ name: '消息数', type: 'line', stack: '总量', smooth: true, data: messageCount }],
        })
      },
    },
  }
</script>

<style scoped>

  .content {
    background-image: url('../../assets/chart/chart3.png');
    background-size: 100% 100%;
    height: 25vh;
    width: 30vw;
  }
</style>